// @flow

import Decimal from 'decimal.js';

const convertCasesAndBottlesToQty = (
  Cases: number,
  Bottles: number,
  Uom: number = 1,
) => {
  const decimal = new Decimal(Bottles / Uom).toDecimalPlaces(5, 1).toNumber();

  return Cases + decimal;
};

export { convertCasesAndBottlesToQty };
